









import { Component, Prop, Vue } from "vue-property-decorator";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import {
  INotificationHook,
  INotificationTemplate
} from "@/models/notifications";

@Component({
  components: {
    "action-form": () =>
      import("@/components/app/admin/automation/actionForm.vue")
  }
})
export default class AdminAutomationEditActionForm extends Vue {
  @Prop({ default: null })
  public templateId!: INotificationTemplate["id"];

  @Prop({ default: null })
  public channelCode!: NotificationChannelCodes;

  @Prop({ default: null })
  public hookId!: INotificationHook["id"];
}
